import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import MuniSpinner from '../../components/MuniSpinner'
import useWindowSize from '../../hooks/useWindowSize'
import Recibo from '../Recibo'
import FormPagar from './FormPagar'
import { buscarReciboPorParams, renderModal } from './handlers'

const Pagar = () => {
  const [recibo, setRecibo] = useState(null)
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)

  const numero_acta = searchParams.get('numero_de_acta')
  const dependencia = searchParams.get('dependencia')
  const documento_titular = searchParams.get('documento')

  const [modalPaginaSeguraIsOpen, setModalPaginaSeguraIsOpen] = useState(false)
  const [modalDismissed, setModalDismissed] = useState(false)
  const windowSize = useWindowSize()

  const handelModalDismissed = () => {
    setModalPaginaSeguraIsOpen(false)
    setModalDismissed(true)
  }

  useEffect(() => {
    // si el tamaño de la pantalla es tablet o menor mostramos el modal
    if (windowSize.width <= 768) {
      if (!recibo && dependencia && dependencia.toUpperCase() === 'MVD') {
        setModalPaginaSeguraIsOpen(true)
      }
    }

    if (windowSize.width > 768 && modalPaginaSeguraIsOpen) {
      setModalPaginaSeguraIsOpen(false)
    }
  }, [recibo, dependencia, windowSize, modalPaginaSeguraIsOpen])

  if (!recibo && dependencia && dependencia.toUpperCase() === 'MVD') {
    // buscarReciboPorParams(numero_acta, dependencia, setRecibo, navigate);

    let numero_acta_autocomplete = dependencia + '-'
    if (numero_acta) {
      numero_acta_autocomplete += numero_acta
    }

    return (
      <div className='container pt-5'>
        <div
          className={
            'bg-white rounded p-2 ' +
            (!recibo ? ' offset-md-2 offset-lg-3 col-sm-8 col-sm-10 col-md-8 col-lg-6 offset-sm-1' : '')
          }
        >
          <div className='p-4'>
            {!modalDismissed && (
              <>
                {renderModal(
                  modalPaginaSeguraIsOpen,
                  setModalPaginaSeguraIsOpen,
                  `¡Atención! Esta página es segura`,
                  <>
                    <p>
                      Usted ha ingresado a un sitio web oficial de la Municipalidad de Neuquén, desarrollado para
                      brindarle servicios de manera ágil y segura.
                    </p>
                    <p>
                      Nuestros sistemas cumplen con estándares de seguridad informática para proteger la información y
                      garantizar la confidencialidad de sus datos. Puede verificar la autenticidad del sitio mediante el
                      candado de seguridad en la barra de direcciones de su navegador y el dominio oficial de la
                      municipalidad.
                    </p>
                    <p>
                      Trabajamos constantemente para ofrecerle una experiencia confiable y eficiente en cada uno de
                      nuestros trámites y servicios digitales.
                    </p>
                    <p>
                      Si tiene alguna duda o consulta, no dude en comunicarse con nuestro equipo a través de los canales
                      oficiales de atención.
                    </p>
                    <p>
                      <span>Atentamente,</span>
                      <br />
                      <span>Municipalidad de Neuquén</span>
                    </p>
                    <div className='d-flex justify-content-center'>
                      <button className='btn btn-primary' onClick={handelModalDismissed}>
                        He leído y entendido
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
            <h4>Pago voluntario {recibo ? 'recibo número ' + recibo?.numeroRecibo?.notacionStandard : null}</h4>
            <hr />
            {!recibo ? (
              <FormPagar
                numero_acta_autocomplete={numero_acta_autocomplete}
                documento_titular_autocomplete={documento_titular}
                setRecibo={setRecibo}
              />
            ) : (
              <Recibo recibo={recibo} setRecibo={setRecibo} />
            )}
          </div>
        </div>
      </div>
    )
  }

  if (!recibo && numero_acta && dependencia && dependencia.toUpperCase() !== 'MVD') {
    buscarReciboPorParams(numero_acta, dependencia, setRecibo, navigate)

    return (
      <div className='container pt-5'>
        <div
          className={
            'bg-white rounded p-2 ' +
            (!recibo ? ' offset-md-2 offset-lg-3 col-sm-8 col-sm-10 col-md-8 col-lg-6 offset-sm-1' : '')
          }
        >
          <MuniSpinner />
        </div>
      </div>
    )
  }

  return (
    <div className='container pt-5'>
      <div
        className={
          'bg-white rounded p-2 ' +
          (!recibo || (recibo && recibo.is_espontaneo && recibo.is_espontaneo === 1)
            ? ' offset-md-2 offset-lg-3 col-sm-8 col-sm-10 col-md-8 col-lg-6 offset-sm-1'
            : '')
        }
      >
        <div className='p-4'>
          <h4>
            Pago voluntario{' '}
            {recibo && !recibo.is_espontaneo && recibo.is_espontaneo !== 1
              ? 'recibo número ' + recibo?.numero?.notacionStandard
              : null}
          </h4>
          <hr />
          {!recibo ? <FormPagar setRecibo={setRecibo} /> : <Recibo recibo={recibo} setRecibo={setRecibo} />}
        </div>
      </div>
    </div>
  )
}

export default Pagar
